export default {
  week: {
    en: 'Week',
    fr: 'Semaine',
    it: 'Settimana',
    nl: 'Week'
  }
};
